<template>
    <v-chip v-if="label" x-small outlined color="success">
        <v-progress-circular indeterminate size="10" width="2" class="mr-1" />
        {{ label }}
    </v-chip>
    <v-tooltip v-else-if="failed" bottom>
        <template v-slot:activator="{ on, attrs }">
            <v-chip v-bind="attrs" v-on="on" x-small outlined color="error">
                <v-icon x-small class="mr-1">mdi-alert-circle-outline</v-icon>
                Falha ao atualizar
            </v-chip>
        </template>
        <span>{{ errorCode || 'Erro desconhecido' }}</span>
    </v-tooltip>
</template>

<script setup>
/**
 * Indicador de andamento da recarga de um gráfico.
 *
 * Alimentado por useChartRefresh: `label` enquanto a run está na fila ou
 * rodando, `failed` quando ela termina em erro.
 */
defineProps({
    label: {
        type: String,
        default: null
    },
    failed: {
        type: Boolean,
        default: false
    },
    errorCode: {
        type: String,
        default: null
    }
})
</script>
